export default __webpack_public_path__ + "static/media/logo_gnt.f9ca3c3e.png";